module.exports = __webpack_public_path__ + "img/section5Logo4.00579277.svg";